var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConnectivityKontrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.21094C2.75 4.14062 2.75 4.07031 2.75 4C2.75 1.9375 4.41406 0.25 6.5 0.25C7.88281 0.25 9.10156 1.02344 9.73438 2.14844C10.0859 1.89062 10.5312 1.75 11 1.75C12.2422 1.75 13.25 2.75781 13.25 4C13.25 4.30469 13.1797 4.5625 13.0859 4.82031C14.4688 5.10156 15.5 6.32031 15.5 7.75C15.5 9.41406 14.1406 10.75 12.5 10.75H3.875C2 10.75 0.5 9.25 0.5 7.375C0.5 5.92188 1.4375 4.65625 2.75 4.21094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectivityKontrol);
export default __webpack_public_path__ + "static/media/IconConnectivityKontrol.052e530695fad46a6ccf92eb4c62c4ff.svg";
export { ForwardRef as ReactComponent };